<template>
  <VLoadingSpinner />
</template>

<script>
import VLoadingSpinner from '@/components/deprecated/atoms/LoadingSpinner.vue';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'CreateEnvelope',
  description: 'Create a new empty Envelope object we can build upon',
  components: {
    VLoadingSpinner,
  },
  async created() {
    // always update company to get latest sharing and reminder settings
    const getting = [this.getCompany()];
    if (!this.editorPermission) {
      getting.push(this.getPermissions());
    }
    await Promise.all(getting);

    let sharing;
    if (this.company?.sharing_type_default === 'everyone') {
      sharing = { everyone_permission_id: this.editorPermission.id };
    }

    const autoRemindHours = this.company?.auto_reminder_default_hours || 0;

    try {
      await this.createEnvelope({ sharing, autoRemindHours });
    } catch (error) {
      if (!error.response) throw error;

      this.$bus.$emit('renderGlobalMessage', ({ message: this.$t('message.fail.creating', { name: 'envelope' }), icon: 'times', type: 'error' }));
    }

    const { fingerprint } = this.creatingEnvelope;
    if (fingerprint) {
      this.$router.replace(`/envelope/create/${fingerprint}`);
    }
  },
  computed: {
    ...mapGetters({
      company: 'company/company',
      editorPermission: 'permissions/editor',
      creatingEnvelope: 'envelopes/creating',
    }),
  },
  methods: {
    ...mapActions({
      getCompany: 'company/GET',
      getPermissions: 'permissions/GET',
      createEnvelope: 'envelopes/CREATE',
    }),
  },
};
</script>
